var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.exportScoreboard}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('exportScoreboard')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }